/** @returns {boolean} */
function isHttpUrl(val) {
  return typeof val === 'string' && /^https?:\/\//i.test(val.trim());
}

/** Primary outbound URL for public event posters — poster link beats Instagram fallback. */
export function outboundEventHref(ev) {
  if (ev?.posterLink && isHttpUrl(ev.posterLink)) return ev.posterLink.trim();
  if (ev?.link && isHttpUrl(ev.link)) return ev.link.trim();
  if (ev?.instagramUrl && isHttpUrl(ev.instagramUrl)) return ev.instagramUrl.trim();
  return '';
}
